
import { Component } from 'nuxt-property-decorator'
import { FSXABaseRichTextElement } from 'fsxa-pattern-library'

@Component({ name: 'Paragraph' })
export default class Paragraph extends FSXABaseRichTextElement {}
